import { render, staticRenderFns } from "./IcoBuilding.vue?vue&type=template&id=5d60f65b"
import script from "./IcoBuilding.vue?vue&type=script&lang=js"
export * from "./IcoBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports